module.exports = __webpack_public_path__ + "img/upload.abc97d3c6dda88bb078d6e4b67a4896c.abc97d3c.png";